import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { FormattedRoute } from '@10xLabs/react-web/components/FormattedRoute'
import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { LabelWrapper, Label, ReturnIcon } from 'features/Bookings/components/Service'

const Wrapper = styled.div<TSFixMe>`
  margin: -10px 0;
`

const Item = styled.div<TSFixMe>`
  margin: 10px 0;
`

export const BaseRuleRoutes = ({ baseRule }: TSFixMe): TSFixMe => {
  return (
    <Wrapper>
      {baseRule.citySegments.map((citySegment: TSFixMe, index: TSFixMe): TSFixMe => {
        return (
          <Item key={index}>
            {baseRule.citySegments.length > 1 && (
              <LabelWrapper>
                {index === 0 ? <ArrowCircleRightIcon /> : <ReturnIcon />}

                <Label>
                  <FormattedMessage
                    id="baseRules.list.routes.count"
                    defaultMessage="Route #{routeNumber}"
                    values={{
                      routeNumber: index + 1
                    }}
                  />
                </Label>
              </LabelWrapper>
            )}

            <FormattedRoute origin={citySegment.origin} destination={citySegment.destination} />
          </Item>
        )
      })}
    </Wrapper>
  )
}
